import _ from 'lodash';

import createModel, { prop } from './lib/create_model';

const InFlightSends = createModel({
  modelName: 'InFlightSends',

  properties: {
    compositionIds: prop([String]).default([]),
  },

  has(compositionId) {
    return _.includes(this.compositionIds, compositionId);
  },

  add(compositionId) {
    this.compositionIds = _.union(this.compositionIds, [compositionId]);
  },

  remove(compositionId) {
    this.compositionIds = _.without(this.compositionIds, compositionId);
  },
});

export default InFlightSends;
